import audio from "../assets/btnAudio.mp3";

export const playAudio = () => {
  new Audio(audio).play();
};
